import untilActions from './actions';

const initialState = {
  forceReload: false,
  scrollToTop: false,
  openNavBar: false,
};

export default function untilReducer(state = initialState, action) {
  switch (action.type) {
    case untilActions.SET_FORCE_RELOAD:
      return { ...state, forceReload: action.payload };
    case untilActions.SCROLL_TO_TOP:
      return { ...state, scrollToTop: action.payload };
    case untilActions.SET_NAV_BAR:
      return { ...state, openNavBar: action.payload };
    default:
      return state;
  }
}
